module.exports = __webpack_public_path__ + "static/media/alex.eaf167a0.svg";